import { render } from "./PdfRenderer.vue?vue&type=template&id=01b431aa&scoped=true"
import script from "./PdfRenderer.vue?vue&type=script&lang=js"
export * from "./PdfRenderer.vue?vue&type=script&lang=js"

import "./PdfRenderer.vue?vue&type=style&index=0&id=01b431aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b431aa"]])

export default __exports__